module.exports = __webpack_public_path__ + "img/1-3.fd970236.png";